import React from "react";
import Loader from "components/LoaderComponent";
import { useAuth } from "context/userContext";
import { Navigate, Outlet } from "react-router-dom";

const PublicGuard = () => {

    const { user, loading } = useAuth();

    if(loading)  return  <Loader />;

    if(user) {
        return <Navigate to="/home" />;
    }

    return <Outlet />;
};

export default PublicGuard;